// extracted by mini-css-extract-plugin
export default {"icon":"OverlayGroup_icon__BtohV","wrapper":"OverlayGroup_wrapper__DUAX2","header":"OverlayGroup_header__u5NZd","seeall":"OverlayGroup_seeall__mMRma"};